<i18n>
{
  "en": {
    "title": "Company Program & Sustainability 2017-2018",
    "description": "Our customer-centric company program focuses on delivering the most innovative, sustainable solutions and supporting the green energy growth of customers around the world. Learn what Do More, Digitize, Innovate, Step Up, and Simplify mean for our employees, as well as our customers’ sustainable development.",
    "ourPeople": {
      "programs": {
        "hero": {
          "title": "Company Programs"
        },
        "txt1": {
          "h2": "Our strategy. Our priorities.",
          "p": "Innovative strategy helps Schneider Electric sustain a workforce that is competitive and highly engaged. The past year was one of great progress in terms of company programs, which include the following customer-centric initiatives:"
        },
        "tableHeader": {
          "h2": "Our five objectives:"
        },
        "txtMedia1": {
          "h2": "Stepping up in 2017",
          "p": "Step Up is known as the people transformation of the company, and it was a key focus in 2017. Step Up is about team-building, talent management, and cultural transformation. It helps us sustain a progressive, world-class workforce. It places focus on things that we want to change to make Schneider a more attractive company for our employees, and more innovative for our customers. Step Up will continue to be a company-wide priority in the year ahead."
        },
        "table": {
          "c1": {
            "title": "Do More",
            "p": "Do more by creating more opportunities for our customers, and for ourselves."
          },
          "c2": {
            "title": "Digitize",
            "p": "Digitize to support our growth and make our customers' lives simpler and better."
          },
          "c3": {
            "title": "Innovate",
            "p": "Innovate our people to grow talents and foster strong employee engagements."
          },
          "c4":{
            "title": "Step Up",
            "p": "Step up our operations for increased efficiency."
          },
          "c5": {
            "title": "Simplify",
            "p": "Simplify for our customers, and simplicity."
          }
        },
        "snapshot": {
          "h2": "Global recognition",
          "card1": {
            "title": "LinkedIn",
            "p1": "LinkedIn Top Companies 2017, second year in a row"
          },
          "card2": {
            "title": "Forbes",
            "p1": "Forbes<sup class='t-sup--small'>&reg;</sup> World's Best Employers"
          },
          "card3": {
            "title": "Fortune",
            "p1": "Fortune<sup class='t-sup--small'>&reg;</sup>'s \"World's Most Admired Companies\" for 2018"
          },
          "card4": {
            "title": "Bloomberg",
            "p1": "2018 Bloomberg<sup class='t-sup--small'>SM</sup> Gender-Equality Index Listing: 104 companies with strong commitments to gender diversity"
          },
          "card5": {
            "title": "Ethisphere Institute ",
            "p1": "2018 \"World's Most Ethical Companies<sup class='t-sup--small'>&reg;</sup>\" by Ethisphere<sup class='t-sup--small'>&reg;</sup> Institute"
          }
        },
        "txtMedia2": {
          "h2": "Policies and progress",
          "p": "The past year brought with it an emphasis on well-being within Schneider Electric. We made progress toward creating an environment where employees can better manage their personal energy. Most important, we reinforced our commitment toward Diversity and Inclusion, including:",
          "ul": [
            "The global launch of our inclusive Global Family Leave Policy",
            "Putting pay equity high on our agenda for the betterment of our employees"
          ]
        }
      }
    }
  },
  "fr": {
    "title": "Company Program & Sustainability 2017-2018",
    "description": "Our customer-centric company program focuses on delivering the most innovative, sustainable solutions and supporting the green energy growth of customers around the world. Learn what Do More, Digitize, Innovate, Step Up, and Simplify mean for our employees, as well as our customers’ sustainable development.",
    "ourPeople": {
      "programs": {
        "hero": {
          "title": "Notre Programme d’Entreprise"
        },
        "txt1": {
          "h2": "Notre stratégie. Nos priorités.",
          "p": "Grâce à une stratégie innovante, Schneider Electric réussit à s'assurer des collaborateurs compétents et fortement mobilisés. L’année 2017 a été marquée par de grands progrès dans notre programme d’entreprise, qui s'articule autour des initiatives suivantes, tournées vers nos clients."
        },
        "tableHeader": {
          "h2": "Nos 5 objectifs :"
        },
        "txtMedia1": {
          "h2": "Step Up en 2017",
          "p": "Ce programme de transformation des collaborateurs et de l’entreprise a fait l’objet d'une attention toute particulière en 2017. Cette initiative, qui repose sur le renforcement de la cohésion des équipes, la gestion des talents et la transformation de la culture d'entreprise nous permet de conserver des collaborateurs de grande qualité. Elle met l’accent sur ce que nous voulons changer pour faire de Schneider Electric une entreprise plus attractive pour nos collaborateurs et plus innovante pour nos clients. Step Up continuera de figurer parmi les priorités de l’ensemble de l’entreprise au cours de l’année à venir."
        },
        "table": {
          "c1": {
            "title": "Do More",
            "p": "En créant plus d’opportunités pour nos clients et pour nous-mêmes."
          },
          "c2": {
            "title": "Digitize",
            "p": "Pour accompagner notre croissance et rendre le quotidien de nos clients plus simple et plus efficace."
          },
          "c3": {
            "title": "Innovate",
            "p": "Pour accroître les compétences de nos collaborateurs tout en renforçant leur engagement."
          },
          "c4":{
            "title": "Step Up",
            "p": "Nos opérations pour une efficacité accrue."
          },
          "c5": {
            "title": "Simplify",
            "p": "Pour nos clients, pour une plus grande facilité."
          }
        },
        "snapshot": {
          "h2": "Reconnaissance mondiale",
          "card1": {
            "title": "LinkedIn",
            "p1": "LinkedIn Top Companies 2017, pour la deuxième année consécutive"
          },
          "card2": {
            "title": "Forbes",
            "p1": "Figure parmi les meilleurs employeurs au monde selon le magazine Forbes"
          },
          "card3": {
            "title": "Fortune",
            "p1": "Édition 2018 du classement Fortune des « Entreprises les plus admirées au monde »"
          },
          "card4": {
            "title": "Bloomberg",
            "p1": "2018 Bloomberg Gender-Equality Index Listing : classement des 104 entreprises affichant un engagement fort en faveur de la diversité hommes-femmes"
          },
          "card5": {
            "title": "Ethisphere Institute",
            "p1": " Figure au classement 2018 des entreprises les plus éthiques (World’s Most Ethical Companies®) établi par l’institut Ethisphere®"
          }
        },
        "txtMedia2": {
          "h2": "Politiques et avancées",
          "p": "En 2017, Schneider Electric a mis l’accent sur le bien-être dans l’entreprise. Nous avons progressé dans l’instauration d'un environnement dans lequel les collaborateurs peuvent mieux gérer leur énergie personnelle. Nous avons surtout renforcé notre engagement en faveur de la diversité et de l’inclusion, notamment à travers :",
          "ul": [
            "le lancement mondial de notre politique global de congé familial ;",
            "la priorité donnée à l'équité salariale, pour le bien-être de nos salariés."
          ]
        }
      }
    }
  }
}
</i18n>
<template>
  <div>
    <Hero
      :loResSrc="require('@/assets/img/our-people/our-people-company-program-hero-lowres.jpg')"
      :hiResSrc="require('@/assets/img/our-people/our-people-company-program-hero.jpg')"
      chapter="04"
      :section="$t('nav.OurPeople')"
      :title="$t('ourPeople.programs.hero.title')" />

    <section class="m-t-120 m-b-120">
      <Txt>
        <h2>{{$t('ourPeople.programs.txt1.h2')}}</h2>
        <p>{{$t('ourPeople.programs.txt1.p')}}</p>
      </Txt>
    </section>
    <section class="l-bg-white l-section-pad">
      <Table class="m-b-45" columns="2">
        <div slot="above">
          <h2 id="companyobjectives">{{$t('ourPeople.programs.tableHeader.h2')}}</h2>
        </div>
        <TableRow>
          <TableCell class="t-grey">
            <h4>{{$t('ourPeople.programs.table.c1.title')}}</h4>
          </TableCell>
          <TableCell bgc="#3dcd58" class="t-white">
            <p class="t-chartbody">{{$t('ourPeople.programs.table.c1.p')}}</p>
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell class="t-white" :bgimg="require('@/assets/img/our-people/GettyImages-527045000.jpg')">
            <h4>{{$t('ourPeople.programs.table.c2.title')}}</h4>
          </TableCell>
          <TableCell>
            <p class="t-chartbody">{{$t('ourPeople.programs.table.c2.p')}}</p>
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell class="t-grey">
            <h4>{{$t('ourPeople.programs.table.c3.title')}}</h4>
          </TableCell>
          <TableCell bgc="#3dcd58" class="t-white">
            <p class="t-chartbody">{{$t('ourPeople.programs.table.c3.p')}}</p>
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell class="t-white" :bgimg="require('@/assets/img/our-people/GettyImages-588367166_a.jpg')">
            <h4>{{$t('ourPeople.programs.table.c4.title')}}</h4>
          </TableCell>
          <TableCell>
            <p class="t-chartbody">{{$t('ourPeople.programs.table.c4.p')}}</p>
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell class="t-grey">
            <h4>{{$t('ourPeople.programs.table.c5.title')}}</h4>
          </TableCell>
          <TableCell bgc="#3dcd58" class="t-white">
            <p class="t-chartbody">{{$t('ourPeople.programs.table.c5.p')}}</p>
          </TableCell>
        </TableRow>
      </Table>
    </section>

    <section class="m-t-120 m-b-120">
      <ImageFull class="m-b-50">
        <img class="img-responsive" src="../../assets/img/our-people/our-people-company-programs-stepping.jpg" alt="">
      </ImageFull>
      <Txt>
        <h2 class="m-b-35">
          {{$t('ourPeople.programs.txtMedia1.h2')}}
        </h2>
        <p id="stepup">{{$t('ourPeople.programs.txtMedia1.p')}}</p>
      </Txt>
    </section>

    <hr>

    <section class="m-t-120 m-b-120">
      <Snapshot>
        <div slot="above">
          <h2 id="hrrecognition">{{$t('ourPeople.programs.snapshot.h2')}}</h2>
        </div>
        <SnapshotCard :double="false">
          <h4 class="t-green-light">{{$t('ourPeople.programs.snapshot.card1.title')}}</h4>
          <div class="t-hr"></div>
          <p v-html="$t('ourPeople.programs.snapshot.card1.p1')"></p>
        </SnapshotCard>

        <SnapshotCard class="t-white" bgc="#3dcd58">
          <h4>{{$t('ourPeople.programs.snapshot.card2.title')}}</h4>
          <div class="t-hr t-hr--white"></div>
          <p v-html="$t('ourPeople.programs.snapshot.card2.p1')"></p>
        </SnapshotCard>

        <SnapshotCard class="t-white minheight" :double="true" :bgimg="require('@/assets/img/our-people/Warsaw_Employer_Branding_2017_14.jpg')">
          <h4>{{$t('ourPeople.programs.snapshot.card3.title')}}</h4>
          <div class="t-hr"></div>
          <p v-html="$t('ourPeople.programs.snapshot.card3.p1')"></p>
        </SnapshotCard>

        <SnapshotCard class="t-white" bgc="#3dcd58" :double="true">
          <h4 class="">{{$t('ourPeople.programs.snapshot.card4.title')}}</h4>
          <div class="t-hr t-hr--white"></div>
          <p v-html="$t('ourPeople.programs.snapshot.card4.p1')"></p>
        </SnapshotCard>

        <SnapshotCard :double="true">
          <h4 class="t-green-light">{{$t('ourPeople.programs.snapshot.card5.title')}}</h4>
          <div class="t-hr"></div>
          <p v-html="$t('ourPeople.programs.snapshot.card5.p1')"></p>
        </SnapshotCard>
      </Snapshot>
    </section>

    <hr>

    <section class="m-t-120 m-b-120">
      <TxtMedia>
        <h2 id="policiesandprogress" slot="main-content">{{$t('ourPeople.programs.txtMedia2.h2')}}</h2>
        <p slot="main-content">{{$t('ourPeople.programs.txtMedia2.p')}}</p>
        <ul slot="main-content">
          <li>{{$t('ourPeople.programs.txtMedia2.ul[0]')}}</li>
          <li>{{$t('ourPeople.programs.txtMedia2.ul[1]')}}</li>
        </ul>
        <img slot="sidebar" src="@/assets/img/our-people/Dubai-Fatima-El-Habachi.jpg" class="img-responsive" alt="">
      </TxtMedia>
    </section>

    <div class="l-content">
      <FooterNav
        nextRoute="OurPeople_InvestmentForGrowth"
        prevRoute="OurPeople_CompanyValues" />
    </div>
  </div>
</template>
<script>
// import FooterNav from '@/components/FooterNav'
import Hero from '@/components/Hero'
import FooterNav from '@/components/FooterNav'
import Txt from '@/components/Txt'
import TxtMedia from '@/components/TxtMedia'
import Snapshot from '@/components/Snapshot'
import SnapshotCard from '@/components/SnapshotCard'
import Table from '@/components/Table'
import TableRow from '@/components/TableRow'
import TableCell from '@/components/TableCell'
import ImageFull from '@/components/ImageFull'

import DoMoreIcon from '@/assets/img/our-people/do-more.svg'
import DigitizeIcon from '@/assets/img/our-people/digitize.svg'
import InnovateIcon from '@/assets/img/our-people/innovate.svg'
import StepUpIcon from '@/assets/img/our-people/step-up.svg'
import SimplifyIcon from '@/assets/img/our-people/simplify.svg'

export default {
  name: 'OurPeople_CompanyPrograms',
  metaInfo () {
    return {
      title: this.$t('title'),
      meta: [
        { name: 'description', content: this.$t('description') }
      ]
    }
  },
  mounted () {
    if (window.location.hash.substr(1).length > 0) {
      this.$nextTick(function () {
        document.getElementById(window.location.hash.substr(1)).scrollIntoView()
      })
    }
  },
  components: {
    Hero,
    FooterNav,
    Txt,
    TxtMedia,
    Snapshot,
    SnapshotCard,
    Table,
    TableRow,
    TableCell,
    ImageFull,

    DoMoreIcon,
    DigitizeIcon,
    InnovateIcon,
    StepUpIcon,
    SimplifyIcon
  }
}
</script>
<style lang="scss" scoped>
.icon {
  width: 48px;
}
</style>



// WEBPACK FOOTER //
// src/pages/our-people/company-programs.vue